<div class="cell shrink batteryDisplay-icon">
    <i [ngClass]="getBatteryLevelFaIcon()"></i>
</div>
<div class="cell  batteryDisplay-percent"
     [class.auto]="!displayVerticalMode"
     [class.shrink]="displayVerticalMode">
    {{batteryLevel}}%
</div>
